var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 17.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9167 31.6667C17.5833 31.6667 17.2917 31.5417 17.0417 31.2917C16.7917 31.0417 16.6667 30.75 16.6667 30.4167V19.5833C16.6667 19.25 16.7917 18.9583 17.0417 18.7083C17.2917 18.4583 17.5833 18.3333 17.9167 18.3333H32.0833C32.4167 18.3333 32.7083 18.4583 32.9583 18.7083C33.2083 18.9583 33.3333 19.25 33.3333 19.5833V30.4167C33.3333 30.75 33.2083 31.0417 32.9583 31.2917C32.7083 31.5417 32.4167 31.6667 32.0833 31.6667H17.9167ZM25 25.375L17.9167 20.7292V30.4167H32.0833V20.7292L25 25.375ZM25 24.125L32 19.5833H18.0208L25 24.125ZM17.9167 20.7292V19.5833V20.7292V30.4167V20.7292Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailWhiteIcon);
export default __webpack_public_path__ + "static/media/mail-white-icon.23aad25d.svg";
export { ForwardRef as ReactComponent };